<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'chat',
    subject: 'Ai',
  },
})

const page = {
  groupTitle: 'AI Assistant',
  icon: 'ri-sparkling-2-line',
  color: 'purple',
  title: 'Chat AI, Draft SOP/CAPA, Analisis IKP',
  description: 'Menggunakan AI Assistant sebagai draf awal — tetap harus ditinjau dan disimpan manual.',
  purpose: 'Panduan memakai AI Assistant untuk mempercepat pekerjaan, dengan aturan penting: AI tidak pernah menyimpan apa pun secara langsung.',
  concept: [
    {
      icon: 'ri-shield-check-line',
      title: 'AI Tidak Pernah Menulis Data Anda',
      text: 'Ini aturan paling penting: hasil AI (draf SOP, draf CAPA, ringkasan) SELALU berupa teks yang harus Anda baca, tinjau, dan simpan sendiri lewat form biasa. AI tidak punya cara untuk langsung menulis ke database Anda.',
    },
    {
      icon: 'ri-file-search-line',
      title: 'AI Hanya Tahu Metadata Dokumen, Bukan Isi Filenya',
      text: 'Kalau Anda bertanya tentang sebuah dokumen, AI menjawab berdasarkan judul/kategori/status-nya saja — AI tidak membaca isi file PDF/DOCX yang Anda unggah, karena sistem memang tidak menyimpan teks isi file di database.',
    },
  ],
  steps: [
    { title: 'Buka menu AI Assistant → Chat', detail: 'Ketik pertanyaan Anda seperti mengobrol biasa.' },
    { title: 'Untuk Draft SOP: buka tab "Draft SOP"', detail: 'Isi topik SOP yang diinginkan, klik "Buat Draf".' },
    { title: 'Tinjau hasil draf yang muncul', detail: 'Klik "Gunakan sebagai Draf Dokumen" — Anda akan diarahkan ke form Buat Dokumen dengan judul sudah terisi.' },
    { title: 'Lengkapi dan klik "Simpan" di form Dokumen', detail: 'Ini langkah WAJIB — draf AI belum tersimpan apa pun sebelum Anda klik Simpan di sini.' },
    { title: 'Untuk Analisis IKP: buka tab "Analisis IKP"', detail: 'Masukkan ID insiden, AI memberi saran akar masalah — tetap harus diverifikasi Tim Mutu.' },
  ],
  warning: 'Saran AI (termasuk Analisis IKP) BUKAN keputusan final. Selalu tinjau dan verifikasi sebelum dijadikan acuan resmi.',
  tips: [
    'Gunakan Knowledge Base (menu AI Assistant → Knowledge Base) untuk menyalin prompt siap pakai yang sudah disiapkan admin.',
    'Kalau AI Provider belum dikonfigurasi, hubungi super-admin untuk mengaturnya di menu Pengaturan.',
  ],
  faq: [
    { q: 'Kenapa fitur AI Assistant tidak muncul di menu saya?', a: 'AI Assistant hanya aktif untuk edisi lisensi "QUALIVA Assistant" — kalau edisi Anda "Standard", fitur ini memang sepenuhnya tersembunyi/dinonaktifkan.' },
    { q: 'Apakah percakapan saya dengan AI tersimpan?', a: 'Ya, seluruh percakapan tersimpan dan bisa dilihat lagi lewat menu AI Assistant → Riwayat.' },
    { q: 'Siapa yang menyediakan API Key AI?', a: 'Fasilitas kesehatan Anda sendiri — QUALIVA tidak menyediakan token AI apa pun. Super-admin mengisi API Key di menu Pengaturan.' },
  ],
  related: [
    { title: 'Pengaturan SMTP & AI Provider', sub: 'Konfigurasi provider AI', icon: 'ri-settings-3-line', color: 'error', to: { name: 'help-administrasi-pengaturan-smtp-ai' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
